import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dir", "width", "height", "fill"];
import React from 'react';

var Plus = function Plus() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9h3c.4 0 .8.3.8.8s-.3.8-.8.8h-3v3c0 .4-.3.8-.8.8s-.7-.5-.7-.9v-3H6c-.4 0-.8-.3-.8-.8S5.6 9 6 9h3V6c0-.4.3-.8.8-.8s.8.3.8.8v3z"
  });
};

var Minus = function Minus() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9c.4 0 .8.3.8.8s-.3.8-.8.8H6c-.4 0-.8-.3-.8-.8S5.6 9 6 9"
  });
};

var ZoomIcon = function ZoomIcon(_ref) {
  var _ref$dir = _ref.dir,
      dir = _ref$dir === void 0 ? 'in' : _ref$dir,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 16.1C11.5 19 6.3 18.5 3.4 15S1 6.3 4.5 3.4 13.2 1 16.1 4.5c2.5 3.1 2.5 7.5 0 10.6l6.2 6.2c.3.3.3.8 0 1.1-.3.3-.7.3-1 0L15 16.1zm-5.2.4c3.7 0 6.8-3 6.8-6.8S13.5 3 9.8 3 3 6 3 9.8s3 6.7 6.8 6.7z"
  }), dir === 'in' ? /*#__PURE__*/React.createElement(Plus, null) : /*#__PURE__*/React.createElement(Minus, null));
};

ZoomIcon.displayName = 'ZoomIcon';
export default ZoomIcon;